import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import kk from './locales/kk.json';
import ru from './locales/ru.json';
import { Languages, SUPPORTED_LANGUAGES } from './shared/constants';

const resources = {
  [Languages.ru]: { translation: ru },
  [Languages.en]: { translation: en },
  [Languages.kk]: { translation: kk }
};

const fallbackLanguage = localStorage.getItem('i18nextLng') || Languages.ru;

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: fallbackLanguage,
    supportedLngs: SUPPORTED_LANGUAGES,
    detection: {
      // Порядок определения языка
      order: ['path', 'localStorage', 'navigator', 'subdomain'],
      // Извлечение языка из первого сегмента пути (/:lang)
      lookupFromPathIndex: 0
    },
    interpolation: {
      escapeValue: false // React самостоятельно экранирует значения
    }
  });

export default i18next;
